
import React, { useState } from "react";
import {
  Box,
  Grid,
  Paper,
  TextField,
  MenuItem,
  Typography,
  Button,
  Alert,
} from "@mui/material";

import bannerImage from "./tool-and-die-maker-6.jpg"; // your image

const courses = [
  "Virtual Robotics - Basic",
  "Virtual Robotics - Advanced",
  "Virtual Robotics - Ultra",
  "Tool & Fixture Design - Basic",
  "Tool & Fixture Design - Advanced",
  "Tool & Fixture Design - Ultra",
  "Digital Factory - Basic",
  "Digital Factory - Advanced",
  "Digital Factory - Ultra",
  "Java Programming",
  "Advanced Java Programming",
  "Java Full Stack",
  "Python Programming",
  "Advanced Python Programming",
  "Python Full Stack",
  "React Development",
  "Flutter Development",
  "Spring Boot & MySQL",
  "HTML, CSS & JavaScript",
];

export default function SubmitEnquiry() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
   
    date: "",
    course: courses[0],
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

 const handleSubmit = (e) => {
  e.preventDefault();

  if (!formData.name.trim()) {
    setError("Please enter name");
    return;
  }

  if (!/^[0-9]{10}$/.test(formData.mobile)) {
    setError("Enter valid 10 digit mobile number");
    return;
  }

  const message =
`🎓 New Course Enquiry

👤 Name: ${formData.name}
📱 Mobile: ${formData.mobile}
📧 Email: ${formData.email}

📅 Date: ${formData.date}
📚 Course: ${formData.course}

Sent From Website`;

  const whatsappUrl =
    `https://api.whatsapp.com/send?phone=918096120173&text=${encodeURIComponent(message)}`;

  window.location.href = whatsappUrl;
};

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "blue",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={10}
        sx={{
          maxWidth: 1350,
          width: "100%",
          overflow: "hidden",
          borderRadius: "20px",
        }}
      >
        <Grid container>
          {/* LEFT IMAGE */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                height: "100%",
                minHeight: 650,
                backgroundImage: `url(${bannerImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  bgcolor: "rgba(0,0,0,0.45)",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "end",
                  p: 4,
                }}
              >
                <Typography variant="h4" fontWeight="bold">
                  International Institute Of Automate
                </Typography>

                <Typography sx={{ mt: 2 }}>
                  Join Industry Ready Training Programs and Build Your Career
                  with Expert Mentors.
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* RIGHT FORM */}
          <Grid item xs={12} md={7}>
            <Box sx={{ p: 4 }}>
              <Typography
                variant="h4"
                fontWeight="bold"
                color="primary"
                mb={1}
              >
                Student Enquiry Form
              </Typography>

              <Typography color="text.secondary" mb={4}>
                Fill your details and send enquiry directly on WhatsApp.
              </Typography>

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}

              {success && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  {success}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </Grid>

                  {/* <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </Grid> */}

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="date"
                      name="date"
                      InputLabelProps={{ shrink: true }}
                      value={formData.date}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="Select Course"
                      name="course"
                      value={formData.course}
                      onChange={handleChange}
                    >
                      {courses.map((course) => (
                        <MenuItem key={course} value={course}>
                          {course}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
  fullWidth
  type="submit"
  variant="contained"
  size="large"
  sx={{
    py: 1.8,
    fontSize: "16px",
    fontWeight: 700,
    backgroundColor: "#ff6b00",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#e65c00",
    },
  }}
>
  Send WhatsApp Enquiry
</Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

